import { render, staticRenderFns } from "./ModalDesignationEdit.vue?vue&type=template&id=48fd3fa6&"
import script from "./ModalDesignationEdit.vue?vue&type=script&lang=js&"
export * from "./ModalDesignationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports